/* ENAEXA i18n — taalswitcher NL / DE / EN.
   Keuze in localStorage (enaexa_lang). Vertaalt tekstnodes + attributen via woordenboek.
   NL = bron. Onvertaalde strings blijven Nederlands. */
(function () {
  "use strict";
  var LKEY = "enaexa_lang";
  var LANGS = ["nl", "de", "en"];
  function lang() { var l = localStorage.getItem(LKEY); return LANGS.indexOf(l) > -1 ? l : "nl"; }

  /* ---- woordenboek: nl-bron -> {de, en} ---- */
  var BASE = {
    // nav / chrome
    "Producten": { de: "Produkte", en: "Products" },
    "Over ons": { de: "Über uns", en: "About us" },
    "Partner worden": { de: "Partner werden", en: "Become a partner" },
    "Blogs": { de: "Blogs", en: "Blog" },
    "Partner platform": { de: "Partnerportal", en: "Partner platform" },
    "Home": { de: "Startseite", en: "Home" },
    "Contact": { de: "Kontakt", en: "Contact" },
    "Bezoek": { de: "Besuch", en: "Visit" },
    "Warmtepompen": { de: "Wärmepumpen", en: "Heat pumps" },
    "Boiler": { de: "Boiler", en: "Water heater" },
    "Warmtepomp 6kW": { de: "Wärmepumpe 6kW", en: "Heat pump 6kW" },
    "Warmtepomp 12kW 1-fase": { de: "Wärmepumpe 12kW 1-phasig", en: "Heat pump 12kW 1-phase" },
    "Warmtepomp 12kW 3-fase": { de: "Wärmepumpe 12kW 3-phasig", en: "Heat pump 12kW 3-phase" },
    "Warmtepomp 18kW": { de: "Wärmepumpe 18kW", en: "Heat pump 18kW" },
    "Boiler 100L": { de: "Boiler 100L", en: "Water heater 100L" },
    "Warmtepompboiler 100L": { de: "Wärmepumpenboiler 100L", en: "Heat pump water heater 100L" },
    "Climalutions 6 kW": { de: "Climalutions 6 kW", en: "Climalutions 6 kW" },
    // footer
    "Duurzame warmte en energieopslag voor particulier en zakelijk.": { de: "Nachhaltige Wärme und Energiespeicherung für Privat und Gewerbe.", en: "Sustainable heat and energy storage for residential and business." },
    "De Berk, Voltaweg 29": { de: "De Berk, Voltaweg 29", en: "De Berk, Voltaweg 29" },
    "Voltaweg 29": { de: "Voltaweg 29", en: "Voltaweg 29" },
    "6101 XK Echt": { de: "6101 XK Echt", en: "6101 XK Echt" },
    "www.enaexa.com": { de: "www.enaexa.com", en: "www.enaexa.com" },
    "© 2026 ENAEXA": { de: "© 2026 ENAEXA", en: "© 2026 ENAEXA" },
    "\u201CDaar Krijg Je Energie Van\u201D": { de: "\u201EDaar Krijg Je Energie Van\u201C", en: "\u201CDaar Krijg Je Energie Van\u201D" },
    // login modal
    "Partnerplatform": { de: "Partnerportal", en: "Partner platform" },
    "Log in met je partneraccount om inkoopprijzen te zien en te bestellen.": { de: "Melden Sie sich mit Ihrem Partnerkonto an, um Einkaufspreise zu sehen und zu bestellen.", en: "Log in with your partner account to see purchase prices and place orders." },
    "E-mailadres": { de: "E-Mail-Adresse", en: "Email address" },
    "Wachtwoord": { de: "Passwort", en: "Password" },
    "Inloggen": { de: "Anmelden", en: "Log in" },
    "Demo-omgeving — elk e-mailadres en wachtwoord werkt.": { de: "Demo-Umgebung — jede E-Mail und jedes Passwort funktioniert.", en: "Demo environment — any email and password works." },
    // platform
    "Bestellen": { de: "Bestellen", en: "Order" },
    "Winkelwagen": { de: "Warenkorb", en: "Cart" },
    "Uitloggen": { de: "Abmelden", en: "Log out" },
    "incl. btw \u00B7 partnerprijs": { de: "inkl. MwSt. \u00B7 Partnerpreis", en: "incl. VAT \u00B7 partner price" },
    "Toegevoegd aan winkelwagen": { de: "Zum Warenkorb hinzugefügt", en: "Added to cart" },
    // generieke knoppen
    "Onze producten": { de: "Unsere Produkte", en: "Our products" },
    "Word partner": { de: "Partner werden", en: "Become a partner" },
    "Bekijk producten": { de: "Produkte ansehen", en: "View products" },
    "Word installatie partner": { de: "Installationspartner werden", en: "Become an installation partner" },
    "Naar alle artikelen": { de: "Alle Artikel ansehen", en: "View all articles" },
    "Meer nieuws \u2192": { de: "Mehr News \u2192", en: "More news \u2192" },
    "Lees artikel": { de: "Artikel lesen", en: "Read article" },
    "Vraag offerte aan": { de: "Angebot anfragen", en: "Request a quote" },
    "Download datasheet": { de: "Datenblatt herunterladen", en: "Download datasheet" },
    "Alle blogs": { de: "Alle Blogs", en: "All blogs" },
    "Meld je direct aan": { de: "Jetzt direkt anmelden", en: "Sign up now" },
    "Zoeken\u2026": { de: "Suchen\u2026", en: "Search\u2026" },
    "Geen artikelen gevonden.": { de: "Keine Artikel gefunden.", en: "No articles found." },
    // homepage hero + secties
    "Het complete verwarmingssysteem": { de: "Das komplette Heizsystem", en: "The complete heating system" },
    "Duurzame warmte en warm tapwater. Volledig elektrisch.": { de: "Nachhaltige Wärme und Warmwasser. Vollständig elektrisch.", en: "Sustainable heat and hot water. Fully electric." },
    "Climalutions warmtepompen en boilers werken naadloos samen, effici\u00ebnt, stil en klaar voor de toekomst.": { de: "Climalutions Wärmepumpen und Boiler arbeiten nahtlos zusammen \u2014 effizient, leise und zukunftssicher.", en: "Climalutions heat pumps and water heaters work seamlessly together \u2014 efficient, quiet and future-proof." },
    "Het complete systeem": { de: "Das komplette System", en: "The complete system" },
    "Partners waar wij trots op zijn": { de: "Partner, auf die wir stolz sind", en: "Partners we are proud of" },
    "Laatste nieuws": { de: "Aktuelle News", en: "Latest news" },
    "Wat onze installateurs zeggen": { de: "Was unsere Installateure sagen", en: "What our installers say" },
    // blog index / titels
    "ENAEXA Blogs": { de: "ENAEXA Blogs", en: "ENAEXA Blog" },
    "Groei die de energietransitie versnelt": { de: "Wachstum, das die Energiewende beschleunigt", en: "Growth that accelerates the energy transition" },
    "Uitbreiding stroomnet vertraagd": { de: "Ausbau des Stromnetzes verzögert", en: "Power grid expansion delayed" },
    "SDE-openingsrondes 2026": { de: "SDE-Förderrunden 2026", en: "SDE subsidy rounds 2026" },
    "Stroomnet ontlasten met ENAEXA": { de: "Das Stromnetz entlasten mit ENAEXA", en: "Relieving the power grid with ENAEXA" },
    "ENAEXA als B2B energiepartner": { de: "ENAEXA als B2B-Energiepartner", en: "ENAEXA as a B2B energy partner" },
    // Over ons
    "ENAEXA \u00B7 Over ons": { de: "ENAEXA \u00B7 Über uns", en: "ENAEXA \u00B7 About us" },
    "Daar krijg je": { de: "Daraus gewinnst du", en: "That's where you get" },
    "energie van": { de: "Energie", en: "energy from" },
    "ENAEXA is de groothandel voor duurzame verwarmingsoplossingen. Wij leveren warmtepompen, boilers en energiesystemen van Climalutions direct aan installateurs in Nederland.": { de: "ENAEXA ist der Großhändler für nachhaltige Heizlösungen. Wir liefern Wärmepumpen, Boiler und Energiesysteme von Climalutions direkt an Installateure in den Niederlanden.", en: "ENAEXA is the wholesaler for sustainable heating solutions. We supply Climalutions heat pumps, water heaters and energy systems directly to installers in the Netherlands." },
    "Passie voor de energietransitie": { de: "Leidenschaft für die Energiewende", en: "Passion for the energy transition" },
    "Direct van de importeur": { de: "Direkt vom Importeur", en: "Direct from the importer" },
    "Relevante artikelen": { de: "Relevante Artikel", en: "Related articles" }
  };

  // Volledig woordenboek (i18n-dict.js) heeft voorrang; BASE is fallback.
  var D = Object.assign({}, BASE, (window.ENAEXA_I18N || {}));

  function tr(s) {
    var L = lang(); if (L === "nl") return null;
    var key = s.replace(/[\s\u00A0]+/g, " ").trim();
    var e = D[key];
    if (!e) {
      // fallback: quote-ongevoelige match (rechte vs. typografische aanhalingstekens)
      var norm = key.replace(/[\u201C\u201D\u201E\u201F"]/g, '"');
      for (var k in D) {
        if (k.replace(/[\u201C\u201D\u201E\u201F"]/g, '"') === norm) { e = D[k]; break; }
      }
    }
    if (e && e[L] != null) {
      // behoud leidende/sluitende witruimte van origineel
      var lead = s.match(/^\s*/)[0], trail = s.match(/\s*$/)[0];
      return lead + e[L] + trail;
    }
    return null;
  }

  function translateNode(root) {
    var L = lang(); if (L === "nl") return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode; if (!p) return NodeFilter.FILTER_REJECT;
        var t = p.nodeName;
        if (t === "SCRIPT" || t === "STYLE" || t === "NOSCRIPT") return NodeFilter.FILTER_REJECT;
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) { var t = tr(node.nodeValue); if (t != null) node.nodeValue = t; });
    // attributen
    (root.querySelectorAll ? root.querySelectorAll("[placeholder],[aria-label],[title],[alt]") : []).forEach &&
      root.querySelectorAll("[placeholder],[aria-label],[title],[alt]").forEach(function (el) {
        ["placeholder", "aria-label", "title"].forEach(function (a) {
          var v = el.getAttribute(a); if (v) { var t = tr(v); if (t != null) el.setAttribute(a, t); }
        });
      });
  }

  /* ---- switcher (dropdown) ---- */
  var NAMES = { nl: "Nederlands", de: "Deutsch", en: "English" };
  function buildSwitcher() {
    var inner = document.querySelector(".site-header__inner");
    if (!inner || document.getElementById("pp-lang")) return;
    var actions = inner.querySelector(".header-actions") || inner.lastElementChild;
    var L = lang();
    var box = document.createElement("div");
    box.id = "pp-lang"; box.className = "pp-lang";
    box.innerHTML =
      '<button type="button" class="pp-lang__btn" id="pp-lang-btn" aria-haspopup="true" aria-expanded="false">' +
      '<span>' + L.toUpperCase() + '</span>' +
      '<svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<div class="pp-lang__menu" role="menu">' +
      LANGS.map(function (l) { return '<button type="button" role="menuitem" data-l="' + l + '"' + (l === L ? ' class="pp-lang--on"' : "") + '>' + NAMES[l] + '</button>'; }).join("") +
      '</div>';
    inner.insertBefore(box, actions.nextSibling);
    var btn = box.querySelector("#pp-lang-btn");
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = box.classList.toggle("pp-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function () { box.classList.remove("pp-open"); });
    box.querySelector(".pp-lang__menu").addEventListener("click", function (e) {
      var b = e.target.closest("button[data-l]"); if (!b) return;
      localStorage.setItem(LKEY, b.getAttribute("data-l"));
      location.reload();
    });
  }

  function injectStyles() {
    if (document.getElementById("pp-lang-styles")) return;
    var s = document.createElement("style");
    s.id = "pp-lang-styles";
    s.textContent = [
      ".site-header__inner{gap:16px;}",
      ".site-header .nav{flex:1 1 auto;justify-content:center;margin:0;}",
      ".pp-lang{position:relative;font-family:var(--font,'Montserrat',sans-serif);margin-left:4px;}",
      ".pp-lang__btn{display:inline-flex;align-items:center;gap:6px;border:1px solid var(--line,#e4e4e6);border-radius:100px;background:#fff;color:var(--ink,#0d0d0d);font-family:inherit;font-size:.78rem;font-weight:700;letter-spacing:.04em;padding:9px 12px;cursor:pointer;transition:border-color .15s,background .15s;}",
      ".pp-lang__btn:hover{background:var(--bg-soft,#f3f3f5);border-color:rgba(13,13,13,.35);}",
      ".pp-lang__btn svg{transition:transform .2s ease;}",
      ".pp-lang.pp-open .pp-lang__btn svg{transform:rotate(180deg);}",
      ".pp-lang__menu{position:absolute;top:calc(100% + 8px);right:0;background:#fff;border:1px solid var(--line,#e4e4e6);border-radius:12px;box-shadow:0 14px 40px rgba(0,0,0,.12);padding:6px;min-width:150px;display:none;z-index:300;}",
      ".pp-lang.pp-open .pp-lang__menu{display:block;}",
      ".pp-lang__menu button{display:flex;align-items:center;justify-content:space-between;width:100%;text-align:left;border:0;background:none;font-family:inherit;font-size:.85rem;font-weight:600;color:var(--ink,#0d0d0d);padding:9px 11px;border-radius:8px;cursor:pointer;transition:background .12s;}",
      ".pp-lang__menu button:hover{background:var(--bg-soft,#f3f3f5);}",
      ".pp-lang__menu button.pp-lang--on{color:#0d0d0d;}",
      ".pp-lang__menu button.pp-lang--on::after{content:'\\2713';color:#caa000;font-weight:800;}",
      "@media(max-width:900px){.site-header .nav{margin:0;}}"
    ].join("\n");
    document.head.appendChild(s);
  }

  function setHtmlLang() { try { document.documentElement.setAttribute("lang", lang()); } catch (e) {} }

  function init() {
    injectStyles();
    setHtmlLang();
    buildSwitcher();
    translateNode(document.body);
    // document title
    var tt = tr(document.title); if (tt != null) document.title = tt;
    // dynamisch toegevoegde nodes (cart, login modal, toast) vertalen
    if (window.MutationObserver && lang() !== "nl") {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes && m.addedNodes.forEach(function (nd) {
            if (nd.nodeType === 1) translateNode(nd);
            else if (nd.nodeType === 3) { var t = tr(nd.nodeValue); if (t != null) nd.nodeValue = t; }
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", init);
  else init();

  /* ---- logo wisselt mee met taal ---- */
  function swapLogos() {
    var l = lang(); if (l === "nl") return;
    var imgs = document.querySelectorAll('img[src*="enaexa-logo"]');
    for (var i = 0; i < imgs.length; i++) {
      var s = imgs[i].getAttribute("src");
      if (s.indexOf("enaexa-logo-de") > -1 || s.indexOf("enaexa-logo-en") > -1) continue;
      imgs[i].setAttribute("src", s.replace("enaexa-logo.png", "enaexa-logo-" + l + ".png"));
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", swapLogos);
  else swapLogos();

})();
